/**
 * Конфигурация навигационного меню с логическими разделами.
 * Каждый объект описывает роль:
 *  - key: уникальный ключ роли
 *  - label: название роли
 *  - description: краткое описание интерфейса
 *  - permission: базовое право доступа
 *  - icon: иконка роли (Bootstrap Icons)
 *  - sections: массив глобальных разделов
 *      - title: название раздела
 *      - items: ссылки внутри раздела
 */

export const navConfig = [
  {
    key: 'admin',
    label: 'Админ',
    description: 'Управление пользователями, ролями и настройками системы.',
    permission: 'pages:admin:view:any',
    icon: 'bi-speedometer2',
    sections: [
      {
        title: 'Панель управления',
        items: [
          { to: '/admin/dashboard', label: 'Главная', icon: 'bi-house', description: 'Основная панель администратора со сводной информацией.' },
          { to: '/admin/history', label: 'История квитанций', icon: 'bi-house', description: 'История квитанций по маршрутам.' },
          { to: '/admin/stats', label: 'Статистика', icon: 'bi-bar-chart', description: 'Общая статистика по работе системы и пользователям.' },
          { to: '/admin/CsvDownload', label: 'Скачать CSV', icon: 'bi-download', description: 'Выгрузка данных пользователей и маршрутов в CSV формат.' },
          { to: '/admin/tokenmanagement', label: 'Управление токенами', icon: 'bi-download', description: 'Токены доступа' },
          { to: '/admin/documents', label: 'Документы', icon: 'bi-download', description: 'Документы из приложения' },
          { to: '/developer/dinamroutes', label: 'Динамические маршуртные листы', icon: 'bi-journal-text', description: '' },

        ],
      },
      {
        title: 'Пользователи и доступ',
        items: [
          { to: '/admin/RolesAndPermissions', label: 'Пользователи и роли', icon: 'bi-people', description: 'Управление ролями, пользователями и правами доступа.' },
        ],
      },
      {
        title: 'Маршруты и данные',
        items: [
          { to: '/admin/routedebug', label: 'Отладка маршрутов', icon: 'bi-bug', description: 'Инструмент для диагностики и проверки маршрутов доставки.' },
          { to: '/admin/removeroutes', label: 'Удалить маршруты', icon: 'bi-x-octagon', description: 'Удаление старых или ошибочных маршрутов.' },
          { to: '/admin/receipts', label: 'Квитаниции вне маршрутов', icon: 'bi-receipt', description: 'Просмотр и обработка квитанций вне маршрутов.' },
          { to: '/admin/RouteBuilder', label: 'Кастомные маршруты', icon: 'bi-diagram-3', description: 'Создание и настройка пользовательских маршрутов.' },
        ],
      },
      {
        title: 'Платформы и инструменты',
        items: [
          { to: '/admin/cdnplatforms', label: 'CDN-площадки', icon: 'bi-globe', description: 'Настройки и управление CDN-площадками.' },
          { to: '/developer/CheckPhoto', label: 'Фото марок', icon: 'bi-camera', description: 'Просмотр и проверка фото марок для контроля качества.' },
        ],
      },
    ],
  },

  {
    key: 'courier',
    label: 'Курьер',
    description: 'Работа с маршрутами и доставками в мобильном интерфейсе.',
    permission: 'pages:courier:view:any',
    icon: 'bi-truck',
    sections: [
      {
        title: 'Основное',
        items: [
          { to: '/courier/routes', label: 'Маршруты', icon: 'bi-flag', description: 'Просмотр и выполнение назначенных маршрутов доставки.' },
        ],
      },
    ],
  },

  {
    key: 'logist',
    label: 'Логист',
    description: 'Планирование, контроль и аналитика логистических процессов.',
    permission: 'pages:logist:view:any',
    icon: 'bi-geo-alt',
    sections: [
      {
        title: 'Мониторинг и управление',
        items: [
          { to: '/logist/routes', label: 'Маршруты', icon: 'bi-signpost-split', description: 'Планирование и оптимизация маршрутов.' },
          { to: '/logist/drivers', label: 'Водители', icon: 'bi-person-lines-fill', description: 'Управление водителями и назначениями маршрутов.' },
          { to: '/logist/tracking', label: 'Трекинг', icon: 'bi-map', description: 'Мониторинг активных доставок и транспорта в реальном времени.' },
        ],
      },
      {
        title: 'Отчёты и аналитика',
        items: [
          { to: '/logist/analytics', label: 'Аналитика', icon: 'bi-graph-up', description: 'KPI, отчёты и показатели эффективности логистики.' },
        ],
      },
    ],
  },

  {
    key: 'dispatcher',
    label: 'Диспетчер',
    description: 'Контроль маршрутов, управление доступом и проверка чеков.',
    permission: 'pages:dispatcher:view:any',
    icon: 'bi-headphones',
    sections: [
      {
        title: 'Управление доступом',
        items: [
          { to: '/dispatcher/accessmanagement', label: 'Управление доступом', icon: 'bi-gear-wide', description: 'Управление доступом к маршрутным листам.' },
          { to: '/dispatcher/giveaccess', label: 'Выдать доступ', icon: 'bi-phone', description: 'Выдача мобильного доступа сотрудникам.' },
        ],
      },
      {
        title: 'Маршруты и чеки',
        items: [
          { to: '/dispatcher/routesdetails', label: 'Детализация маршрутов', icon: 'bi-speedometer', description: 'Мониторинг маршрутов и статусов курьеров.' },
          { to: '/dispatcher/undelivered', label: 'Недоставленные', icon: 'bi-exclamation', description: 'Список недоставленных заказов и причины.' },
          { to: '/dispatcher/fiscalchecks', label: 'Пробить чеки', icon: 'bi-receipt', description: 'Проверка фискальных чеков по завершённым заказам.' },
        ],
      },
    ],
  },

  {
    key: 'manager',
    label: 'Управляющий',
    description: 'Контроль эффективности, отчёты и финансовая аналитика.',
    permission: 'pages:manager:view:any',
    icon: 'bi-briefcase',
    sections: [
      {
        title: 'Мониторинг маршрутов',
        items: [
          { to: '/manager/routesprogress', label: 'Прогресс', icon: 'bi-graph-up', description: 'Отслеживание выполнения маршрутов по регионам и сотрудникам.' },
          { to: '/manager/routesprogressdetails', label: 'Детализация', icon: 'bi-graph-up', description: 'Подробные данные по выполнению маршрутов.' },
        ],
      },
      {
        title: 'Отчёты и финансы',
        items: [
          { to: '/manager/finstatistics', label: 'Статистика', icon: 'bi-pie-chart', description: 'Финансовая аналитика по доставкам и отделениям.' },
          { to: '/manager/report', label: 'Отчёты', icon: 'bi-file-earmark-text', description: 'Создание и экспорт отчётов по ключевым показателям.' },
        ],
      },
    ],
  },

  {
    key: 'storekeeper',
    label: 'Кладовщик',
    description: 'Учёт паллет, контейнеров и складских операций.',
    permission: 'pages:storekeeper:view:any',
    icon: 'bi-box-seam',
    sections: [
      {
        title: 'Складской учёт',
        items: [
          { to: '/storekeeper/containers', label: 'Паллеты и поддоны', icon: 'bi-basket', description: 'Учёт и отслеживание паллет, поддонов и контейнеров.' },
        ],
      },
    ],
  },

  {
    key: 'developer',
    label: 'Разработчик',
    description: 'Технические инструменты, загрузка и отладка данных.',
    permission: 'pages:developer:view:any',
    icon: 'bi-code-square',
    sections: [
      {
        title: 'Посмотреть что это',
        items: [
          { to: '/developer/DownloadMarks', label: 'Скачать марки', icon: 'bi-journal-text', description: 'Версия 2.0' },
          { to: '/developer/Marks', label: 'Загрузка марок из CSV', icon: 'bi-journal-text', description: '' },
          { to: '/developer/CheckPhoto', label: 'Просмотр фото', icon: 'bi-journal-text', description: 'Посмотреть прикрепленные фото к квитанциям' },
          { to: '/developer/Tapalka', label: 'Просто тапалка по приколу', icon: 'bi-journal-text', description: '' },
          { to: '/developer/AddMarksToRoute', label: 'Добавление марок к маршрутам', icon: 'bi-journal-text', description: '' },
          { to: '/developer/CatalogManagement', label: 'Каталог товров мб', icon: 'bi-journal-text', description: '' },
        ],
      },
      {
        title: 'Debug',
        items: [
          { to: '/developer/TestCheckSubscriptionPage', label: 'Проверка подписки на чек', icon: 'bi-journal-text', description: '' },
          { to: '/developer/TestiDataK2', label: 'Тест сканера TSD', icon: 'bi-journal-text', description: '' },
          { to: '/developer/pagecont', label: 'Просто тест скролла', icon: 'bi-journal-text', description: '' },
          { to: '/developer/travel', label: 'Время отправления и прибытия', icon: 'bi-journal-text', description: '' },


        ],
      },

    ],
  },
];
